import * as React from 'react';
import { IReferralItem } from '../../../repositories/cpd/entities/v1_get_referrals_listing/ReferralItem';
import { Modal, useDeviceType } from '@cian/ui-kit';
import { ReferralsItemModalContent, ReferralsListItem } from '../../../components/ReferralsList';
import { STATUS_MAPPER } from './constants';

export const ReferralsListItemContainer: React.FC<IReferralItem> = props => {
  const { status } = props;

  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const [isModalOpen, setModalOpen] = React.useState<boolean>(false);

  const handleOpenModal = React.useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleCloseModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      <ReferralsListItem
        {...props}
        headingIcon={STATUS_MAPPER[status].icon}
        headingStatusName={STATUS_MAPPER[status].name}
        onClick={handleOpenModal}
      />

      <Modal open={isModalOpen} onOpenChange={handleCloseModal} size="S">
        <ReferralsItemModalContent
          isDesktop={isDesktop}
          {...STATUS_MAPPER[status].modalContent}
          onBtnClick={handleCloseModal}
        />
      </Modal>
    </>
  );
};
